import * as React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import { useNavigate } from 'react-router-dom';

import { useGlobalNavigatePrompt } from '../core/context/GlobalNavigatePromptContext';

function UnsavedChangesDialog() {
  const {
    isPromptOpen, navigateTo, navigateOptions, setIsPromptOpen, setNavigateTo, setNavigateOptions,
  } = useGlobalNavigatePrompt();
  const navigate = useNavigate();

  const handleClose = () => {
    setIsPromptOpen(false);
    setNavigateTo(undefined);
    setNavigateOptions(undefined);
  };

  const handleConfirmNavigation = () => {
    if (navigateTo !== undefined) {
      handleClose();
      navigate(navigateTo, navigateOptions);
    }
  };

  return (
    <Dialog open={isPromptOpen} onClose={handleClose}>
      <DialogTitle>Are you sure you want to leave this page?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Hey there! It looks like you&apos;re in the middle of writing
          something and you haven&apos;t saved all of your content.
          <br />
          <br />
          Save before you go!
        </DialogContentText>
        <DialogActions>
          <Button onClick={handleClose}>Stay</Button>
          <Button variant="contained" color="primary" onClick={handleConfirmNavigation}>Leave</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export default UnsavedChangesDialog;
